import { AbstractOption } from './option.abstract';

const delimiter = ':';

export interface SalesPersonOptionValue {
  id: string;
  name: string;
}

export class SalespersonOption extends AbstractOption<string, SalespersonOption> {
  private readonly _id: string;
  private readonly _fullName: string;

  constructor(kwargs: { id: string; name: string }) {
    super();
    this._id = kwargs.id;
    this._fullName = kwargs.name;
    this.optionValue = [this._id, this._fullName].join(delimiter);
  }

  static fromOptionValue(option: string): SalespersonOption {
    const tup = option.split(delimiter);
    return new SalespersonOption({ id: tup[0], name: tup[1] });
  }

  toOptionValue(): string {
    return this.optionValue;
  }

  get id(): string {
    return this.optionValue.split(delimiter)[0];
  }

  get fullName(): string {
    return this.optionValue.split(delimiter)[1];
  }
}
